import React from "react";

const Contact = () => {
  return (
    <div>
      <h4 style={{ color: "orange", textAlign: "center", marginTop: "60px" }}>
        Nmae: Ashikul islam
      </h4>
      <h5 style={{ color: "orange", textAlign: "center" }}>
        Phone: 017040*****
      </h5>
      <h5 style={{ color: "orange", textAlign: "center" }}>
        Email: ashikulislamb84@gmail.com
      </h5>
      <h5 style={{ color: "orange", textAlign: "center" }}>
        Address: jamlpur gograbari
      </h5>
    </div>
  );
};

export default Contact;
